import React from 'react';
import { Drawer, Box, IconButton } from '@mui/material';
import ReviewForm, { StageDataProps } from '../reviewer/reviewForm';

interface WorkflowDrawerProps {
  open: boolean;
  onClose: () => void;
  projectId: string;
  stageId: string | null;
  stageData: StageDataProps;
}

const WorkflowDrawer: React.FC<WorkflowDrawerProps> = ({
  open,
  onClose,
  projectId,
  stageId,
  stageData,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '50vw',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <Box p={2} pt={0}>
          {stageId && (
            <ReviewForm projectId={projectId} stageData={stageData} onClose={onClose}/>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default WorkflowDrawer;